<template>
  <div>
    <!-- <van-search v-model="staff" placeholder="请搜索员工" @search="onSearch" @clear="onSearch" shape="round" /> -->
    <div class="filter" v-show="showFilter">
      <van-dropdown-menu class="search-group" active-color="#3974c4">
        <van-dropdown-item :title="deptName" ref="item" @close="menuClose">
          <tree-select :items="deptList" :active-ids.sync="deptIds" :main-active-index.sync="activeIndex"
            @itemclick="onitemclick" />
        </van-dropdown-item>
      </van-dropdown-menu>
      <div class="search">
        <van-search v-model="staff" placeholder="搜索" @search="onSearch" @clear="onSearch" shape="round" />
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell v-for="(item, index) in staffList" :key="index">
        <div v-show="item.qwId!=qwAccount.qwId" style="display: flex;justify-content: space-between;font-size: 16px;">
          <img class="avatar" width="32" height="32"
            :src="item.avatar || require('@/assets/images/contact_default.png')">
          <div class="content">
            <div>
              <span>{{item.qwName}}</span>
              <span style="font-size:12px;margin-left:5px;color:#999;" v-if="item.nickName">({{item.nickName}})</span>
            </div>
            <div style="color:#999;">{{item.position}}</div>
          </div>
          <van-button style="margin-right: 10px;" type="info" @click="selectStaffConfirm(item)">分配
          </van-button>
        </div>
      </van-cell>
    </van-list>
    <van-dialog v-model="showDialog" title="客户匹配是否正确？" confirmButtonText="正确" cancelButtonText="错误"
      confirmButtonColor="#3974c4" @confirm="clickRight" @cancel="clickError" show-cancel-button>
      <div style="display: flex;justify-content: center;align-items:center">
        <img :src="qwClientData.avatar" style="margin-right: 5px;width: 50px;border-radius: 50%;" />
        <span>{{qwClientData.clientName}}</span>
      </div>
    </van-dialog>
    <van-dialog v-model="showDialog2" title="分配关系确认？" confirmButtonText="正确" cancelButtonText="错误"
      confirmButtonColor="#3974c4" @confirm="confirm" @cancel="showDialog2=false" show-cancel-button>
      <div class="select-confirm">
        将<span>{{qwAccount.qwName}}</span>客户<span>{{qwClientData.clientName}}</span>分配给<span>{{selectItem.qwName}}</span>?
      </div>
    </van-dialog>
  </div>
</template>
<script>
//import preventBack from 'vue-prevent-browser-back'  //组件内单独引入
import treeSelect from '../../components/treeSelect.vue'
export default {
  //mixins: [preventBack],//注入
  components: { treeSelect },
  data () {
    return {
      loading: false,
      finished: false,
      error: false,
      staff: '',
      href: {
        corpId: ''
      },
      staffList: [],
      showDialog: false,
      qwClientData: {},
      page: 0,
      pageCount: 10,
      theConversationId: '',
      deptIds: [],
      deptList: [],
      activeIndex: 0,
      deptId: '',
      deptName: '',
      showFilter: false,
      showDialog2: false,
      qwAccount: {},
      selectItem: {}
    }
  },
  created () {
    this.href.corpId = this.$store.state.auth.corpId || localStorage.getItem('corpId') || this.$route.query.corpId
    this.getDeptTree()
    this.getQwAccount()
  },
  methods: {
    onitemclick (data) {
      if (data.text) {
        this.deptName = data.text || ''
      }
      this.deptId = data.id
      if (!(data.children && data.children.length > 0)) {
        this.$refs.item.toggle();
      }
    },
    menuClose () {
      this.page = 1
      this.staffList = []
      this.getDeptUserList()
    },
    confirm () {
      this.selectStaff(this.selectItem)
    },
    selectStaffConfirm (val) {
      this.selectItem = val
      this.showDialog2 = true
    },
    getDeptTree () {
      this.$http.get(`/scrm/v1/wxcp-chat-tool/o/findDeptTree?corpId=${this.href.corpId}`).then((response) => {
        this.deptList = response.data
        this.deptList.unshift({
          text: '全部',
          id: ''
        })
        if (this.deptList.length > 0) {
          this.deptName = this.deptList[0].text || ''
          this.deptId = this.deptList[0].id
        }
      })
    },
    // 获取绑定的企微宝账号
    getQwAccount () {
      this.$http.get("/scrm/v1/wxcp-chat-tool/o/getQwAccount", {
        params: {
          corpId: this.href.corpId,
        }
      }).then((response) => {
        let { data, msg, success, code } = response
        if (success) {
          this.$store.dispatch('setQwAccountId', data.id)
          this.qwAccount = data
          this.getJsSDK()
        } else {
          // 失败则说明企微宝账号未绑定或未托管
          if (code == 20011) {
            this.$dialog.alert({
              showConfirmButton: false,
              message: `请授权托管个人企微账号`,
            });
          } else {
            this.$dialog.alert({
              showConfirmButton: false,
              message: `请确认是否开通微分账号及绑定企业微信`,
            });
          }
        }
      })
    },
    //获取jsSDK信息
    getJsSDK () {
      this.$http.get("/scrm/v1/wxcp-corp/p/getJsSDK", {
        params: {
          corpId: this.href.corpId,
          url: window.location.href.split("#")[0], //'http://scrm-wxwork-ui.ngrok.gznino.com:8080/'
        },
      }).then((res) => {
        if (res.code === 1) {
          this.config = res.data;
          this.getconfig();
        }
      })
    },
    getconfig () {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.config.corpid, // 必填，企业微信的corpID
        timestamp: this.config.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.config.nonceStr, // 必填，生成签名的随机串
        signature: this.config.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ["agentConfig"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      let that = this;
      wx.ready(function() {
        wx.agentConfig({
          corpid: that.config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: that.config.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: that.config.timestamp, // 必填，生成签名的时间戳
          nonceStr: that.config.nonceStr, // 必填，生成签名的随机串
          signature: that.config.agentSignature, // 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ["selectExternalContact", "getCurExternalContact"], //必填
          success: function(res) {
            // 回调
            wx.invoke("getCurExternalContact", {}, function(res) {
              if (res.err_msg == "getCurExternalContact:ok") {
                that.userId = res.userId; //返回当前外部联系人userId
                that.$store.dispatch('setExternalUserId', res.userId)
                // 判断客户是否已匹配
                that.$http.get("/scrm/v1/wxcp-chat-tool/o/getQwClient", {
                  params: {
                    corpId: that.href.corpId,
                    externalUserId: that.userId,
                    accountId: that.$store.state.auth.qwAccountId,
                  },
                }).then((res) => {
                  const { code, data, msg } = res
                  if (code === 1) {
                    if (data.hasBind) { //为真则已匹配
                      // 返回客户信息，确认匹配是否正确
                      that.qwClientData = data.qwClient
                      that.theConversationId = data.conversationId
                      that.getQwClientFollower()
                    } else {
                      // 未匹配则去选择客户进行匹配
                      that.$router.push('/selectcustomer')
                    }
                  } else {
                    that.$router.push('/selectcustomer')
                  }
                });
              } else {
              }
            });
          }
        });
      });
    },
    //不断会话是否分配
    getQwClientFollower () {
      this.$http.get("/scrm/v1/wxcp-chat-tool/o/getQwClientFollower", {
        params: {
          corpId: this.href.corpId,
          conversationId: this.theConversationId,
          accountId: this.$store.state.auth.qwAccountId,
        },
      }).then((res) => {
        const { code, data, msg } = res
        if (data && data.length > 0) {
          console.log('that.showDialog = true')
          this.$router.push({
            path: '/myAssignment',
            query: {
              conversationId: this.theConversationId
            }
          })
        } else {
          this.showDialog = true
        }
      });
    },
    onSearch () {
      this.page = 1
      this.staffList = []
      this.loading = false
      this.finished = false,
        this.getDeptUserList()
    },
    // 匹配正确
    clickRight () {
      this.page++
      this.getDeptUserList()
      this.showFilter = true
    },
    // 匹配错误 (去进行客户匹配)
    clickError () {
      this.$router.push('/selectcustomer')
    },
    // 获取部门员工列表
    getDeptUserList () {
      this.$http.post(`/scrm/v1/wxcp-chat-tool/o/findQwBindUserByPage?corpId=${this.href.corpId}`, {
        page: this.page,
        pageCount: this.pageCount,
        keyword: this.staff || undefined,
        deptId: this.deptId || undefined
      }).then((response) => {
        let { data, code, total } = response
        this.loading = false
        if (code === 1) {
          if (data.records.length !== 0) {
            this.staffList.push(...data.records)
          } else {
            this.finished = true;
          }
        } else {
          this.$toast(`${msg}`)
        }
        if (this.staffList.length >= total) {
          this.finished = true;
        }
      })
    },
    onLoad () {
      if (this.staffList.length > 0) {
        this.page++
        this.getDeptUserList()
      }

    },
    // 选中员工,进行分配
    selectStaff (val) {
      this.$http.post(`/scrm/v1/wxcp-chat-tool/o/allotSessionToFollower?corpId=${this.href.corpId}`, {
        accountId: this.$store.state.auth.qwAccountId,
        conversationId: this.theConversationId,
        followerId: val.bindUserId
      }).then((response) => {
        let { code, msg } = response
        this.showDialog2 = false
        if (code === 1) {
          this.$toast('分配成功')
          this.$router.push({
            path: '/myAssignment',
            query: {
              conversationId: this.theConversationId
            }
          })
        } else {
          this.$toast(`${msg}`)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.van-button {
  height: 32px;
  border-radius: 6px;
}
.avatar {
  vertical-align: middle;
}
.avatar {
  width: 45px;
  height: 45px;
  border-radius: 4px;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-left: 5px;
}
.filter {
  box-shadow: 0 0.05333rem 0.32rem rgba(100, 101, 102, 0.12);
  display: flex;
  .search-group {
    flex: 1;
    /deep/.van-dropdown-menu__bar {
      box-shadow: initial;
    }
  }
  .van-sidebar-item--select {
    color: #3974c4;
  }
  .van-sidebar-item--select::before {
    background-color: #3974c4;
  }
}
.select-confirm {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  span {
    color: #ee0a24;
    padding: 0 3px;
  }
}
</style>
